(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product.hot-reload"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-hot-reload')) {
    class ProductHotReload extends HTMLElement {
      constructor() {
        super();
        this.cache = new Map();
        this.activeRequests = new Map();
        this.loadingTimeout = null;
        this.supportsViewTransitions = 'startViewTransition' in document;

        this.addEventListener('change', (event) => this.onVariantChange(event));
        this.addEventListener('mouseover', (event) => this.onMouseOver(event));
      }

      connectedCallback() {
        this.updateInventoryData();
      }

      showLoadingState() {
        this.loadingTimeout = setTimeout(() => {
          this.classList.add('product-hot-reload--loading');
        }, 200);
      }

      hideLoadingState() {
        if (this.loadingTimeout) {
          clearTimeout(this.loadingTimeout);
          this.loadingTimeout = null;
        }
        this.classList.remove('product-hot-reload--loading');
      }

    buildRequestUrl(input, options) {
      const opts = options || {};

      const productFormElement = this.querySelector('form');

      if (!productFormElement) {
        console.warn('[BUILD URL] No form found in product-hot-reload component');
      }

      const sectionId = this.dataset.sectionId;

      let newProductUrl, optionValueId;

      if (input.type === 'radio') {
        newProductUrl = input.dataset.productUrl;
        optionValueId = input.dataset.optionValueId;
      } else if (input.tagName === 'SELECT') {
        const selectedOption = input.options[input.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl;
        optionValueId = selectedOption.dataset.optionValueId;
      }

      if (!newProductUrl || !optionValueId) {
        console.warn('[BUILD URL] Missing product URL or option value ID', { newProductUrl, optionValueId });
        return null;
      }

      let selectedOptionValues = [];

      if (Array.isArray(opts.optionValueIds) && opts.optionValueIds.length > 0) {
        selectedOptionValues = opts.optionValueIds.slice();
      } else {
        const checkedRadios = Array.from(this.querySelectorAll('input[type="radio"]:checked[data-option-value-id]'));
        selectedOptionValues = checkedRadios.map(({ dataset }) => dataset.optionValueId).filter(Boolean);

        const selects = Array.from(this.querySelectorAll('select[data-variant-input]'));
        selects.forEach(select => {
          const selectedOption = select.options[select.selectedIndex];
          if (selectedOption && selectedOption.dataset.optionValueId) {
            selectedOptionValues.push(selectedOption.dataset.optionValueId);
          }
        });

        if (input.type === 'radio' && !input.checked) {
          const currentOptionName = input.name;
          selectedOptionValues = selectedOptionValues.filter(id => {
            const foundInput = this.querySelector(`input[data-option-value-id="${id}"]`);
            return foundInput && foundInput.name !== currentOptionName;
          });
          selectedOptionValues.push(optionValueId);
        }
      }

      const params = selectedOptionValues.length > 0 ? `&option_values=${selectedOptionValues.join(',')}` : '';
      const finalUrl = `${newProductUrl}?section_id=${sectionId}${params}`;
      return finalUrl;
    }

      resolveOptionValueIds(changedInput) {
        const variantJsonEl = this.querySelector('[data-variant-json]');
        const optionsMapEl = this.querySelector('[data-product-options-json]');
        if (!variantJsonEl || !optionsMapEl) return null;
        let variants, optionsMap;
        try {
          variants = JSON.parse(variantJsonEl.textContent);
          optionsMap = JSON.parse(optionsMapEl.textContent);
        } catch (e) {
          return null;
        }
        if (!Array.isArray(variants) || variants.length === 0) return null;
        if (!Array.isArray(optionsMap) || optionsMap.length === 0) return null;

        const optionNames = optionsMap.map(o => o.name);

        const idLookup = optionsMap.map(o => {
          const m = new Map();
          (o.values || []).forEach(v => m.set(v.name, v.id));
          return m;
        });

        const radiosByOption = new Map();
        this.querySelectorAll('input[type="radio"][data-product-hot-reload-trigger]').forEach(r => {
          if (!radiosByOption.has(r.name)) radiosByOption.set(r.name, []);
          radiosByOption.get(r.name).push(r);
        });
        const selectsByOption = new Map();
        this.querySelectorAll('select[data-variant-input]').forEach(s => {
          selectsByOption.set(s.name, s);
        });

        const desired = {};
        optionNames.forEach(name => {
          const radios = radiosByOption.get(name) || [];
          const checked = radios.find(r => r.checked);
          if (checked) {
            desired[name] = checked.value;
          } else {
            const sel = selectsByOption.get(name);
            if (sel) desired[name] = sel.value;
          }
        });

        const exact = variants.find(v => v.available && optionNames.every((name, idx) => v[`option${idx + 1}`] === desired[name]));
        if (exact) return null;

        const changedName = changedInput.name;
        const changedIdx = optionNames.indexOf(changedName);
        if (changedIdx === -1 || desired[changedName] == null) return null;

        const fallback = variants.find(v => v.available && v[`option${changedIdx + 1}`] === desired[changedName]);
        if (!fallback) return null;

        const ids = [];
        for (let i = 0; i < optionNames.length; i++) {
          const valueString = fallback[`option${i + 1}`];
          const id = idLookup[i] ? idLookup[i].get(valueString) : null;
          if (id == null) return null;
          ids.push(id);
        }
        return ids;
      }

      onMouseOver(event) {

        const label = event.target.closest('label');
        if (!label) {
          return;
        }

        let input = label.querySelector('input[type="radio"][data-product-hot-reload-trigger]');

        if (!input && label.hasAttribute('for')) {
          const inputId = label.getAttribute('for');
          const escapedId = CSS.escape(inputId);
          input = this.querySelector(`#${escapedId}[data-product-hot-reload-trigger]`);
        }

        if (!input) {
          return;
        }

        if (input.checked) {
          return;
        }

        const requestUrl = this.buildRequestUrl(input);
        if (!requestUrl) {
          return;
        }

        if (this.cache.has(requestUrl)) {
          return;
        }

        if (this.activeRequests.has(requestUrl)) {
          return;
        }

        this.fetchContent(requestUrl);
      }

      fetchContent(requestUrl) {
        const fetchPromise = fetch(requestUrl)
          .then(response => response.text())
          .then(responseText => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.cache.set(requestUrl, html);
            this.activeRequests.delete(requestUrl);
            return html;
          })
          .catch(error => {
            this.activeRequests.delete(requestUrl);
            throw error;
          });

        this.activeRequests.set(requestUrl, fetchPromise);
        return fetchPromise;
      }

      async onVariantChange(event) {
        if (!event.target.hasAttribute('data-product-hot-reload-trigger')) return;

        event.preventDefault();
        event.stopPropagation();

        const resolvedIds = this.resolveOptionValueIds(event.target);
        const requestUrl = this.buildRequestUrl(event.target, resolvedIds ? { optionValueIds: resolvedIds } : undefined);
        if (!requestUrl) {
          return;
        }

        const productUrl = this.dataset.productUrl;
        this.showLoadingState();

        try {
          let html;
          if (this.cache.has(requestUrl)) {
            html = this.cache.get(requestUrl);
          } else if (this.activeRequests.has(requestUrl)) {
            html = await this.activeRequests.get(requestUrl);
          } else {
            html = await this.fetchContent(requestUrl);
          }

          await this.updateProductWithTransition(html, productUrl, event.target.id);
        } catch (error) {
          console.error('[CHANGE] Error updating product content:', error);
        } finally {
          this.hideLoadingState();
        }
      }

      async updateProductWithTransition(html, productUrl, targetId) {
        let updatedHtml = html.getElementById(this.id);

        if (!updatedHtml) {
          updatedHtml = html.querySelector('product-hot-reload');
        }

        if (!updatedHtml) {
          console.error('[UPDATE] Could not find updated product-hot-reload element');
          return;
        }

        const updatedVariantJsonEl = updatedHtml.querySelector('[data-current-variant-json]');
        if (updatedVariantJsonEl) {
          try {
            const updatedVariantData = JSON.parse(updatedVariantJsonEl.textContent);

            if (!updatedVariantData || updatedVariantData === null) {
              console.warn('[UPDATE] ⚠️ Invalid variant combination - using product base price as fallback');

              const currentPriceEl = this.querySelector('[data-product-price]');
              if (currentPriceEl) {
                const updatedPriceEl = updatedHtml.querySelector('[data-product-price]');
                if (updatedPriceEl && currentPriceEl) {
                  updatedPriceEl.innerHTML = currentPriceEl.innerHTML;
                }
              }
            }
          } catch (e) {
            console.error('[UPDATE] Failed to parse updated variant JSON:', e);
          }
        }

        await this.surgicalUpdate(updatedHtml);

        this.updateInventoryData();
        this.reinitializeImageSlider();
        this.reinitializeImageZoom();
        this.reinitializeCollapsibles();
        this.updateMasterSelect();
        this.updateBrowserHistory(productUrl);

        if (targetId) {
          try {
            const escapedId = CSS.escape(targetId);
            const targetElement = this.querySelector(`#${escapedId}`);
            if (targetElement) {
              targetElement.focus();
            }
          } catch (error) {
            console.warn('[UPDATE] Could not focus target element:', targetId, error);
          }
        }
      }

      async surgicalUpdate(updatedHtml) {
        this.dataset.productUrl = updatedHtml.dataset.productUrl;
        this.dataset.variantId = updatedHtml.dataset.variantId;

        const selectorsToUpdate = [
          '[data-variant-json]',
          '[data-current-variant-json]',
          '[data-current-variantmeta-json]',
          '[data-variantmeta-json]',
          '[data-product-tags-json]',
        ];

        selectorsToUpdate.forEach(selector => {
          const currentElements = this.querySelectorAll(selector);
          const newElements = updatedHtml.querySelectorAll(selector);

          currentElements.forEach((currentEl, index) => {
            const newEl = newElements[index];
            if (newEl) {
              currentEl.innerHTML = newEl.innerHTML;
            }
          });
        });

        const currentImages = this.querySelector('[data-product-images]');
        const newImages = updatedHtml.querySelector('[data-product-images]');
        if (currentImages && newImages) {
          const currentSlides = currentImages.querySelectorAll('.product-main-slide:not(.product-main-slide--3d)');
          const newSlides = newImages.querySelectorAll('.product-main-slide:not(.product-main-slide--3d)');

          currentSlides.forEach((slide, index) => {
            const newSlide = newSlides[index];
            if (newSlide) {
              slide.innerHTML = newSlide.innerHTML;
              Array.from(newSlide.attributes).forEach(attr => {
                slide.setAttribute(attr.name, attr.value);
              });
            }
          });

          const currentThumbs = this.querySelector('.product__thumbs');
          const newThumbs = updatedHtml.querySelector('.product__thumbs');
          if (currentThumbs && newThumbs) {
            const thumbsToUpdate = currentThumbs.querySelectorAll('.product__thumb-item:not(.product__thumb-item--3d)');
            const newThumbsItems = newThumbs.querySelectorAll('.product__thumb-item:not(.product__thumb-item--3d)');

            thumbsToUpdate.forEach((thumb, index) => {
              const newThumb = newThumbsItems[index];
              if (newThumb) {
                thumb.innerHTML = newThumb.innerHTML;
                Array.from(newThumb.attributes).forEach(attr => {
                  thumb.setAttribute(attr.name, attr.value);
                });
              }
            });
          }
        }

        const currentBlocks = this.querySelector('[data-product-blocks]');
        const newBlocks = updatedHtml.querySelector('[data-product-blocks]');
        if (currentBlocks && newBlocks) {
          const mobilePlaceholder = currentBlocks.querySelector('#vectary_model_placeholder');
          const model3D = mobilePlaceholder ? mobilePlaceholder.querySelector('custom-3d-model') : null;

          if (model3D && mobilePlaceholder) {
            const currentChildren = Array.from(currentBlocks.children);
            const newChildren = Array.from(newBlocks.children);

            currentChildren.forEach((currentChild, index) => {
              const newChild = newChildren[index];
              if (!newChild) return;

              const childPlaceholder = currentChild.querySelector('#vectary_model_placeholder');
              if (childPlaceholder) {
                const blockChildren = Array.from(currentChild.children);
                const newBlockChildren = Array.from(newChild.children);

                blockChildren.forEach(child => {
                  if (child.id !== 'vectary_model_placeholder') {
                    child.remove();
                  }
                });

                newBlockChildren.forEach(newChildEl => {
                  if (newChildEl.id !== 'vectary_model_placeholder') {
                    const clone = newChildEl.cloneNode(true);
                    const placeholderIndexInNew = newBlockChildren.findIndex(c => c.id === 'vectary_model_placeholder');
                    const thisIndexInNew = newBlockChildren.indexOf(newChildEl);

                    if (thisIndexInNew < placeholderIndexInNew) {
                      currentChild.insertBefore(clone, childPlaceholder);
                    } else {
                      currentChild.appendChild(clone);
                    }
                  }
                });

                if (!childPlaceholder.contains(model3D)) {
                  childPlaceholder.appendChild(model3D);
                }
              } else {
                currentChild.innerHTML = newChild.innerHTML;
                Array.from(newChild.attributes).forEach(attr => {
                  currentChild.setAttribute(attr.name, attr.value);
                });
              }
            });
          } else {
            currentBlocks.innerHTML = newBlocks.innerHTML;
          }
        }
      }

      reinitializeImageSlider() {
        const sliderContainer = document.querySelector('[data-product-photos]');
        if (!sliderContainer) {
          return;
        }

        const slides = sliderContainer.querySelectorAll('.product-main-slide');

        if (slides.length <= 1) {
          if (slides[0]) {
            slides[0].classList.add('is-selected');
          }
          return;
        }

        const has3DSlide = sliderContainer.querySelector('.product-main-slide--3d');
        const isDesktop = !theme.config.bpSmall;
        const existingFlickity = window.Flickity && window.Flickity.data(sliderContainer);

        if (isDesktop && has3DSlide && existingFlickity) {
          const currentIndex = existingFlickity.selectedIndex;

          existingFlickity.reloadCells();
          existingFlickity.resize();
          existingFlickity.select(currentIndex, false, true);

          this.rebindThumbNav(currentIndex);

          document.dispatchEvent(new CustomEvent('product:sliderInitialized'));
          return;
        }

        let startingIndex = 0;
        slides.forEach((slide, index) => {
          if (slide.classList.contains('starting-slide')) {
            startingIndex = index;
          }
        });

        if (existingFlickity) {
          existingFlickity.destroy();
        }

        const sliderArgs = {
          adaptiveHeight: true,
          avoidReflow: true,
          childNav: document.querySelector('.product__thumbs--scroller'),
          childNavScroller: document.querySelector('.product__thumbs'),
          childVertical: sliderContainer.dataset.thumbPosition === 'beside',
          contain: true,
          dragThreshold: 25,
          fade: false,
          friction: 0.8,
          initialIndex: startingIndex,
          pageDots: false,
          prevNextButtons: sliderContainer.dataset.arrows === 'true',
          rightToLeft: theme.config.rtl,
          setGallerySize: true,
          wrapAround: true
        };

        if (theme.config.bpSmall && sliderContainer.querySelector('.product-main-slide--3d')) {
          sliderArgs.cellSelector = '.product-main-slide:not(.product-main-slide--3d)';
        }

        if (window.theme && window.theme.Slideshow) {
          try {
            new theme.Slideshow(sliderContainer, sliderArgs);
            document.dispatchEvent(new CustomEvent('product:sliderInitialized'));
          } catch (error) {
            console.error('[SLIDER INIT] Error creating Flickity:', error);
          }
        } else {
          console.warn('[SLIDER INIT] theme.Slideshow not available');
        }
      }

      rebindThumbNav(activeIndex) {
        const productSection = this.querySelector('[data-section-type="product"]');
        if (!productSection) return;

        const sectionId = productSection.dataset.sectionId;

        let slideshowWrapper = null;
        if (theme.sections && theme.sections.instances) {
          const productInstance = theme.sections.instances.find(inst => inst.id === sectionId);
          if (productInstance && productInstance.flickity) {
            slideshowWrapper = productInstance.flickity;
          }
        }

        if (!slideshowWrapper || !slideshowWrapper.args.childNav) return;

        const thumbContainer = slideshowWrapper.args.childNav;

        slideshowWrapper.childNavEls = thumbContainer.querySelectorAll('.product__thumb-item:not(.hide)');
        slideshowWrapper.childNavLinks = thumbContainer.querySelectorAll('.product__thumb-item:not(.hide) a');

        if (!slideshowWrapper.childNavLinks.length) return;

        slideshowWrapper.childNavLinks.forEach((link, i) => {
          link.setAttribute('data-index', i);
          link.classList.remove('is-active');

          if (!link.closest('.product__thumb-item--3d')) {
            link.addEventListener('click', function(evt) {
              evt.preventDefault();
              slideshowWrapper.goToSlide(slideshowWrapper.getChildIndex(evt.currentTarget));
            });
            link.addEventListener('focus', function(evt) {
              slideshowWrapper.goToSlide(slideshowWrapper.getChildIndex(evt.currentTarget));
            });
            link.addEventListener('keydown', function(evt) {
              if (evt.keyCode === 13) {
                slideshowWrapper.goToSlide(slideshowWrapper.getChildIndex(evt.currentTarget));
              }
            });
          }
        });

        if (activeIndex >= 0 && activeIndex < slideshowWrapper.childNavLinks.length) {
          slideshowWrapper.childNavLinks[activeIndex].classList.add('is-active');
        }
      }

      reinitializeImageZoom() {
        const imageContainer = document.querySelector('[data-product-images]');
        if (!imageContainer) {
          return;
        }

        if (imageContainer.dataset.zoom === 'false') {
          return;
        }

        const productSection = document.querySelector('[data-section-type="product"]');
        if (!productSection) {
          return;
        }

        const sectionId = productSection.dataset.sectionId;

        if (window.theme && window.theme.Photoswipe) {
          try {
            new theme.Photoswipe(imageContainer, sectionId);
          } catch (error) {
          }
        }
      }

      reinitializeCollapsibles() {
        if (window.theme && window.theme.collapsibles && typeof theme.collapsibles.init === 'function') {
          try {
            theme.collapsibles.init(this);
          } catch (error) {
          }
        }
      }

      updateMasterSelect() {
        const variantId = this.dataset.variantId;
        if (!variantId) {
          console.warn('[MASTER SELECT] No variant ID found');
          return;
        }

        const masterSelect = this.querySelector('select[name="id"][data-product-select]');
        if (!masterSelect) {
          console.warn('[MASTER SELECT] Master select element not found');
          return;
        }

        masterSelect.value = variantId;
        masterSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }

      triggerVariantImageChange() {
        const variantJsonElement = this.querySelector('[data-current-variant-json]');
        if (!variantJsonElement) {
          return;
        }

        try {
          const variantText = variantJsonElement.textContent;

          if (!variantText || variantText.trim() === '') {
            return;
          }

          const variant = JSON.parse(variantText);

          if (!variant) {
            return;
          }

          if (!variant.featured_media || !variant.featured_media.id) {
            return;
          }

          const productSection = this.querySelector('[data-section-type="product"]');
          if (!productSection) {
            return;
          }

          productSection.dispatchEvent(new CustomEvent('variantImageChange', {
            detail: {
              variant: variant
            },
            bubbles: true
          }));

          const mainSlider = productSection.querySelector('.product-main-slide');

          if (mainSlider) {
            const targetThumb = productSection.querySelector(`.product__thumb[data-id="${variant.featured_media.id}"]`);

            if (targetThumb) {
              const imageIndex = parseInt(targetThumb.getAttribute('data-index'), 10);
              const flickityInstance = window.Flickity && window.Flickity.data(mainSlider);

              if (flickityInstance && typeof imageIndex === 'number' && imageIndex >= 0) {
                flickityInstance.select(imageIndex);
              }
            }
          }
        } catch (error) {
        }
      }

      syncVariantAvailability() {
        const radios = this.querySelectorAll('input[type="radio"][data-option-value-id]');
        const optionStateMap = new Map();

        Array.from(radios).forEach(radio => {
          const valueId = radio.getAttribute('data-option-value-id');
          if (valueId) {
            const isDisabled = radio.classList.contains('disabled') ||
                               (radio.parentElement && radio.parentElement.classList.contains('disabled'));
            optionStateMap.set(valueId, isDisabled);
          }
        });

        radios.forEach(radio => {
          const valueId = radio.getAttribute('data-option-value-id');
          if (!valueId || !optionStateMap.has(valueId)) return;

          const shouldBeDisabled = optionStateMap.get(valueId);
          const parentDiv = radio.parentElement;

          radio.classList.toggle('disabled', shouldBeDisabled);

          if (parentDiv && parentDiv.classList.contains('variant-input')) {
            parentDiv.classList.toggle('disabled', shouldBeDisabled);
          }

          let label = radio.nextElementSibling;
          if (label && label.tagName === 'LABEL') {
            label.classList.toggle('disabled', shouldBeDisabled);
          } else if (radio.id) {
            label = this.querySelector(`label[for="${CSS.escape(radio.id)}"]`);
            if (label) {
              label.classList.toggle('disabled', shouldBeDisabled);
            }
          }

          if (parentDiv) {
            const swatch = parentDiv.querySelector('.color-swatch');
            if (swatch) {
              swatch.classList.toggle('disabled', shouldBeDisabled);
            }
          }
        });
      }

      updateInventoryData() {
        window.inventories = window.inventories || {};

        this.querySelectorAll('.js-product-inventory-data').forEach(el => {
          const productId = el.dataset.productId;
          if (!productId) return;

          window.inventories[productId] = {};

          el.querySelectorAll('.js-variant-inventory-data').forEach(variantEl => {
            const variantId = variantEl.dataset.id;
            if (!variantId) return;

            window.inventories[productId][variantId] = {
              quantity: variantEl.dataset.quantity,
              policy: variantEl.dataset.policy,
              incoming: variantEl.dataset.incoming,
              next_incoming_date: variantEl.dataset.date
            };
          });
        });
      }

      updateBrowserHistory(productUrl) {
        const variantId = this.dataset.variantId;
        const url = new URL(productUrl, window.location.origin);
        const currentUrl = new URL(window.location.href);

        for (const [key, value] of currentUrl.searchParams.entries()) {
          if (key !== 'variant') {
            url.searchParams.set(key, value);
          }
        }

        if (variantId) {
          url.searchParams.set('variant', variantId);
        }

        window.history.pushState({}, '', url.toString());
      }
    }

    customElements.define('product-hot-reload', ProductHotReload);
  }
  } catch(e) { console.error(e); }
})();

})();
